import './empty-state.css';
export default {
  "emptyState": "pf-v5-c-empty-state",
  "emptyStateActions": "pf-v5-c-empty-state__actions",
  "emptyStateBody": "pf-v5-c-empty-state__body",
  "emptyStateContent": "pf-v5-c-empty-state__content",
  "emptyStateFooter": "pf-v5-c-empty-state__footer",
  "emptyStateIcon": "pf-v5-c-empty-state__icon",
  "emptyStateTitleText": "pf-v5-c-empty-state__title-text",
  "modifiers": {
    "xs": "pf-m-xs",
    "sm": "pf-m-sm",
    "lg": "pf-m-lg",
    "xl": "pf-m-xl",
    "fullHeight": "pf-m-full-height"
  }
};